import axios from "axios";
import ConstantList from "../appConfig";
const API_PATH = ConstantList.API_EN_POINT + "/screen-template";

export const pagingScreenTemplate = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getScreenTemplateById = (id) => axios.get(API_PATH + "/get-by-id/" + id);

export const saveOrUpdate = ScreenTemplate => axios.post(API_PATH + '/save', ScreenTemplate);

export const deleteScreenTemplate = id => axios.delete(API_PATH + '/mark-delete/' + id);

export const saveOrUpdateByStaffAndScreen = (obj) => axios.post(API_PATH + "/save-or-update-by-staff-and-screen", obj);

export const searchItemByPage = (obj) => axios.post(API_PATH + "/search-template-by-page", obj);

export const saveConceptTemplate = ScreenTemplate => axios.post(API_PATH + '/save-concept-template', ScreenTemplate);

export const getConceptTemplateById = (id) => axios.get(API_PATH + "/get-concept-template-by-id/" + id);

export const markDeleteConceptTemplate = id => axios.delete(API_PATH + '/mark-delete-concept-template/' + id);
